<template>
  <div class="follow-page" v-loading="loading">
    <div class="follow-controls">
      <el-checkbox v-model="unSaleOnly" size="small" @change="getAnnounceData(1)">只看未发售作品</el-checkbox>
      <span>{{ rows.length }} 条当前页记录</span>
    </div>

    <el-table class="follow-table" :data="rows" empty-text="暂无收藏的预告" size="small">
      <el-table-column label="作品" min-width="260">
        <template slot-scope="scope">
          <div class="work-cell">
            <el-image class="work-cover" :src="scope.row.cover" fit="contain"><div slot="error" class="cover-empty"><i class="el-icon-picture-outline"></i></div></el-image>
            <div class="work-copy">
              <span class="work-id">{{ scope.row.gameId }}</span>
              <a v-if="scope.row.gameUrl" :href="scope.row.gameUrl" target="_blank" rel="noopener noreferrer">{{ scope.row.gameName }}</a>
              <span v-else>{{ scope.row.gameName }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="社团" min-width="130">
        <template slot-scope="scope"><a v-if="scope.row.authorUrl" :href="scope.row.authorUrl" target="_blank" rel="noopener noreferrer">{{ scope.row.authorName }}</a><span v-else>{{ scope.row.authorName }}</span></template>
      </el-table-column>
      <el-table-column label="发售日期" prop="saleDate" width="125"></el-table-column>
      <el-table-column label="状态" width="90"><template slot-scope="scope"><el-tag :type="scope.row.isSale ? 'info' : 'warning'" size="mini">{{ scope.row.isSale ? '已发售' : '未发售' }}</el-tag></template></el-table-column>
      <el-table-column label="售价" prop="price" width="95"></el-table-column>
      <el-table-column label="标签" min-width="200"><template slot-scope="scope"><div class="tag-list"><el-tag v-for="tag in tagParts(scope.row.tag)" :key="tag" size="mini" type="info">{{ tag }}</el-tag></div></template></el-table-column>
      <el-table-column label="操作" width="85" fixed="right"><template slot-scope="scope"><el-button type="text" size="small" @click="removeFollow(scope.row.id)">取消收藏</el-button></template></el-table-column>
    </el-table>

    <div class="follow-mobile">
      <el-card v-for="row in rows" :key="row.id" class="follow-card" shadow="never">
        <div class="mobile-work">
          <el-image class="work-cover" :src="row.cover" fit="contain"><div slot="error" class="cover-empty"><i class="el-icon-picture-outline"></i></div></el-image>
          <div class="work-copy">
            <span class="work-id">{{ row.gameId }}</span>
            <a v-if="row.gameUrl" :href="row.gameUrl" target="_blank" rel="noopener noreferrer">{{ row.gameName }}</a>
            <span v-else>{{ row.gameName }}</span>
            <el-tag :type="row.isSale ? 'info' : 'warning'" size="mini">{{ row.isSale ? '已发售' : '未发售' }}</el-tag>
          </div>
        </div>
        <div class="mobile-meta"><span>{{ row.authorName }}</span><span>{{ row.saleDate || '日期未定' }}</span></div>
        <div class="tag-list"><el-tag v-for="tag in tagParts(row.tag)" :key="tag" size="mini" type="info">{{ tag }}</el-tag></div>
        <div class="mobile-actions"><strong>{{ row.price ? `¥${row.price}` : '价格未定' }}</strong><el-button type="text" size="small" @click="removeFollow(row.id)">取消收藏</el-button></div>
      </el-card>
      <el-empty v-if="!rows.length && !loading" description="暂无收藏的预告"></el-empty>
    </div>

    <div class="follow-footer">
      <label>每页 <el-select v-model="pageSize" size="mini" @change="getAnnounceData(1)"><el-option v-for="size in [25, 50, 75, 100]" :key="size" :label="String(size)" :value="size"></el-option></el-select></label>
      <el-pagination background layout="prev, pager, next" :page-count="totalPage" :pager-count="paginationPager" :current-page="current" @current-change="getAnnounceData"></el-pagination>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'UserAnnounce',
  data() {
    return { pageSize: 25, totalPage: 1, current: 1, paginationPager: 5, unSaleOnly: true, rows: [], loading: false }
  },
  mounted() { this.getAnnounceData(1) },
  methods: {
    tagParts(tags) { return String(tags || '').split(' ').filter(Boolean) },
    async getAnnounceData(pageNo) {
      this.loading = true
      try {
        const res = await axios.get('/api/user/announce', {
          params: { pageNo, pageSize: this.pageSize, unSaleOnly: this.unSaleOnly },
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        })
        if (res.data.code !== 200) throw new Error(res.data.message)
        const data = res.data.data
        this.totalPage = data.pageCount || 1
        this.current = data.current || 1
        this.rows = data.rows || []
      } catch (error) { this.$message.error(error.message || '加载预告收藏失败') }
      finally { this.loading = false }
    },
    async removeFollow(id) {
      try {
        const res = await axios.delete('/api/user/setting/announce', {
          data: { id }, headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        })
        if (res.data.code !== 200) throw new Error(res.data.message)
        this.$message.success('已取消收藏')
        this.getAnnounceData(this.current)
      } catch (error) { this.$message.error(error.message || '取消收藏失败') }
    }
  }
}
</script>

<style scoped>
.follow-page { min-height: 180px; }
.follow-controls, .follow-footer, .mobile-actions { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.follow-controls { margin-bottom: 12px; }
.follow-controls > span { color: #909399; font-size: 11px; }
.follow-table { background: transparent; }
.follow-table >>> th, .follow-table >>> tr { background: rgba(255, 255, 255, .25); }
.follow-table >>> td, .follow-table >>> th.is-leaf { border-bottom-color: rgba(220, 223, 230, .7); }
.work-cell, .mobile-work { display: flex; align-items: center; gap: 10px; min-width: 0; }
.work-cover { flex: none; width: 80px; height: 60px; border-radius: 6px; background: rgba(245, 247, 250, .7); }
.cover-empty { display: grid; place-items: center; width: 100%; height: 100%; color: #909399; }
.work-copy { display: flex; flex-direction: column; align-items: flex-start; gap: 3px; min-width: 0; font-size: 12px; }
.work-copy > a, .work-copy > span:not(.work-id) { display: -webkit-box; overflow: hidden; -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
.work-id { color: #409eff; font-size: 10px; font-weight: 700; }
a { color: #409eff; text-decoration: none; }
.tag-list { display: flex; flex-wrap: wrap; gap: 4px; }
.tag-list >>> .el-tag { max-width: 100%; overflow: hidden; text-overflow: ellipsis; }
.follow-footer { margin-top: 16px; padding-top: 12px; border-top: 1px solid rgba(220, 223, 230, .7); }
.follow-footer label { display: flex; align-items: center; gap: 6px; color: #909399; font-size: 11px; white-space: nowrap; }
.follow-footer >>> .el-select { width: 70px; }
.follow-mobile { display: none; }
@media (max-width: 767px) {
  .follow-table { display: none; }
  .follow-mobile { display: block; }
  .follow-card { margin-bottom: 10px; border: 1px solid rgba(220, 223, 230, .8); border-radius: 10px; background: rgba(255, 255, 255, .48); }
  .follow-card >>> .el-card__body { padding: 11px; }
  .mobile-work .work-cover { width: 96px; height: 72px; }
  .mobile-meta { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 4px 10px; margin: 10px 0 7px; color: #909399; font-size: 11px; }
  .mobile-actions { margin-top: 8px; border-top: 1px solid rgba(220, 223, 230, .65); color: #409eff; }
  .follow-footer { flex-wrap: wrap; justify-content: center; }
  .follow-footer >>> .el-pagination { padding: 0; }
}
</style>
